'use client';

import { getIsAnonymous } from '@/lib/LocalStorage';
import { appendCampaignParamsToUrl } from '@/lib/persistCampaignParams';
import { ProfileTab } from '@/lib/ProfileTab';
import { appRPC } from '@/lib/utils';
import { WebLink } from '@/lib/WebLinks';
import { Package } from 'lucide-react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/navigation';
import { useCallback, useState } from 'react';
import { Button } from './ui/button';

const OrderTrackView = dynamic(() => import('./OrderTrackView'), { ssr: false });

type OrderTrackViewEntryProps = {
  isSidebar?: boolean;
  isApp?: boolean;
};

export default function OrderTrackViewEntry({
  isSidebar = false,
  isApp = false,
}: OrderTrackViewEntryProps) {
  const router = useRouter();
  const [showForm, setShowForm] = useState(false);

  const navigateToOrders = useCallback(() => {
    const targetUrl = appendCampaignParamsToUrl(`${WebLink.PROFILE}?type=${ProfileTab.ORDERS}`);

    if (isApp) {
      const RPCcheck = appRPC('route', 'navigateWithUrl', { url: targetUrl, target: 'user' });
      if (!RPCcheck && window) {
        window.location.href = targetUrl;
        return;
      }
      if (RPCcheck) {
        return;
      }
    }

    router.push(targetUrl);
  }, [isApp, router]);

  const onTriggerClick = useCallback(() => {
    if (!getIsAnonymous()) {
      navigateToOrders();
      return;
    }
    setShowForm(true);
  }, [navigateToOrders]);

  if (showForm) {
    return <OrderTrackView isSidebar={isSidebar} isApp={isApp} initialPopoverOpen />;
  }

  if (isSidebar) {
    return (
      <Button
        type="button"
        className="flex items-center space-x-2 px-2 h-[38px] rounded-full bg-[#5E6AFF1A] hover:bg-[#5E6AFF1A] transition-all duration-300 w-1/2 focus-visible:ring-0 focus-visible:ring-offset-0"
        onClick={onTriggerClick}
      >
        <Package className="size-5 text-white" />
        <span className="text-[12px] font-medium text-white line-clamp-1">Sipariş Takibi</span>
      </Button>
    );
  }

  return (
    <>
      <Button
        type="button"
        className="hidden sm:flex rounded-full h-12 justify-center items-center hover:cursor-pointer bg-[#5E6AFF1A] hover:bg-hzc_purple_400 transition-all hover:scale-105 duration-300 text-hzc_beige_100"
        aria-label="Sipariş Takibi"
        onClick={onTriggerClick}
      >
        <span className="py-2 text-sm font-medium">Sipariş Takibi</span>
      </Button>
      <Button
        type="button"
        className="flex sm:hidden rounded-full h-8 w-[42px] p-0 justify-center items-center hover:cursor-pointer bg-[#5E6AFF1A] hover:bg-hzc_purple_400 transition-all hover:scale-105 duration-300 text-hzc_beige_100"
        aria-label="Siparişlerim"
        onClick={onTriggerClick}
      >
        <Package className="size-6" />
      </Button>
    </>
  );
}
